// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3wqLQ","inputDescription":"styles_inputDescription__1Nnai"};